<template>


  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="80px">


      <div class="common-form">答题详情</div>
      <div class="table-wrap">
        <el-row>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">用户ID：</span>
              <span v-if="form.user">{{form.user.user_id}}</span>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">用户姓名：</span>
              <span v-if="form.user">{{ form.user.real_name }}</span>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">获得积分：</span>
              {{ form.points }}
            </div>
          </el-col>

          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">答题情况：</span>
              <span>共{{form.totalnum}}题/答对{{form.num}}题</span>
            </div>
          </el-col>
        </el-row>
      </div>

      <el-table :data="form.topic_ids" size="small" border style="width: 100%;margin: 30px;" v-loading="loading" >
        <el-table-column prop="topic_id" label="ID" width="70px" align="center"></el-table-column>
        <el-table-column prop="title" label="题目标题" width="200px" align="center"></el-table-column>
        <el-table-column prop="type.text" label="题目类型" width="100px" align="center"></el-table-column>
        <el-table-column prop="useranswer" label="学生答案" width="100px" align="center">
          <template slot-scope="scope">
            <span class="green" v-if="scope.row.useranswer == scope.row.answer">{{scope.row.useranswer}}</span>
            <span class="red" v-if="scope.row.useranswer != scope.row.answer">{{scope.row.useranswer}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="answer" label="题目答案" width="100px" align="center"></el-table-column>
        <el-table-column prop="parse" label="题目答案解析" width="200px" align="center"></el-table-column>
        <el-table-column prop="points" label="题目积分" width="100px" align="center"></el-table-column>
        <el-table-column prop="option" label="题目选项" align="center">
          <template slot-scope="scope">
                <el-table
                  :data="scope.row.option"
                  align="center"
                  >
                  <el-table-column
                    width="80px"
                    align="center"
                    prop="value" label="选项">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="option" label="内容" >
                  </el-table-column>

                </el-table>
              </template>

        </el-table-column>

      </el-table>

    </el-form>
    <div class="common-button-wrapper">
      <el-button size="small" type="info" @click="cancelFunc">返回上一页</el-button>

    </div>
  </div>
</template>

<script>
  import TopicApi from '@/api/topic.js';


export default {
  components: {},
  data() {
    return {

      /*form表单数据*/
      form: {

      },

      topic:[],
      problemset:[],
      /*是否正在加载*/
      loading: false
    };
  },
  props:{

  },
  created() {
    this.record_id = this.$route.query.record_id;

    this.getData();

  },
  methods: {

    /*获取数据*/
    getData() {
      let self = this;
      TopicApi.getAnswerDetail({
        record_id: self.record_id
      }, true)
        .then(res => {
          self.form = res.data.detail;
          // self.problemset = res.data.model.project.problemset;
          //self.form.answer = JSON.parse(res.data.detail.answer);
          // self.topic = res.data.model.project.problemset.problemsettopic;
          self.form.topic_ids.forEach((item,index)=>{

            self.form.answer.forEach((item1,index1)=>{
                if(item.topic_id == item1.topic_id){
                  self.form.topic_ids[index].useranswer = item1.answer
                }

            });
          });
           console.log(self.form)
          self.loading=false;

        })
        .catch(error => {});
    },
    /*取消*/
    cancelFunc() {

      this.$router.back(-1);
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/topic/record/detail.vue